var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 259,
    viewBox: "0 0 198 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.058 80.9746C122.542 80.9746 115.205 73.7457 115.205 64.7905V0.0539551H25.0357C11.4784 0.0539551 0.419922 10.8973 0.419922 24.3302V234.724C0.419922 248.103 11.4784 259 25.0357 259H172.571C186.128 259 197.133 248.103 197.133 234.724V80.9746H132.058ZM66.7177 205.808C56.563 192.213 53.4262 174.519 58.3706 158.227H59.9656C65.7075 158.227 71.5025 159.198 76.9786 161.14L76.766 162.758C76.5533 165.132 76.447 167.452 76.447 169.825C76.447 191.35 85.6978 212.012 101.648 226.146C87.9308 224.42 75.3305 217.137 66.7177 205.808ZM109.995 225.607C92.5031 212.66 82.0826 191.944 82.0826 169.825C82.0826 167.668 82.0826 165.456 82.3484 163.352C89.7916 166.912 96.331 172.307 101.382 178.996C111.377 192.267 114.567 209.585 109.995 225.607ZM116.693 221.345C119.511 205.323 115.63 188.599 105.794 175.544C100.265 168.153 92.9816 162.165 84.7409 158.173L83.199 157.418C86.3358 139.777 96.2247 123.97 110.739 113.505C128.709 126.452 139.448 147.437 139.448 169.825C139.448 189.624 131.101 208.344 116.693 221.345Z",
    fill: "#FF8E00",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBlur);
export default __webpack_public_path__ + "static/media/projectBlur.41ef8ce0f0b888e2a49180ca2b96219a.svg";
export { ForwardRef as ReactComponent };